import React from 'react';

function EducationExperienceComponent() {
    return (
        <div id="education" className="container-fluid parallax tt-overlay-bg">
            <div className="container">
                <div className="row" style={{ paddingBottom: "50px", paddingTop: "71px" }}>
                    <div className="col-md-12">
                        <h2 className="text-center title">Education & Experiences</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-5">
                        <div className="cv_edu_exp mt-3">
                            <div className="cv_edu_exp_box mt-4">
                                <div className="row">
                                    <div className="cv_edu_exp_year tag-year">2017 - 2018</div>
                                    <div className="col-lg-12">
                                        <div className="cb_edu_exp_detail">
                                            <h4>Mastère Spécialisé Big Data</h4>
                                            <h5>Télécom ParisTech - Paris, France</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="cv_edu_exp_box mt-4">
                                <div className="row">
                                    <div className="cv_edu_exp_year tag-year">2012 - 2017</div>
                                    <div className="col-lg-12">
                                        <div className="cb_edu_exp_detail">
                                            <h4>Diplôme d'ingénieurs informatique</h4>
                                            <h5>ESIEA - Paris, France</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="cv_edu_exp_box mt-4">
                                <div className="row">
                                    <div className="cv_edu_exp_year tag-year">2016</div>
                                    <div className="col-lg-12">
                                        <div className="cb_edu_exp_detail">
                                            <h4>Echange universitaire</h4>
                                            <h5>Polytechnique - Montréal, Canada</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-5 offset-md-2">
                        <div className="cv_edu_exp mt-3">
                        <div className="cv_edu_exp_box mt-4">
                                <div className="row">
                                    <div className="cv_edu_exp_year tag-year">2025 - Aujourd'hui</div>
                                    <div className="col-lg-12">
                                        <div className="cb_edu_exp_detail">
                                            <h4>Head of Data</h4>
                                            <h5>Indy - Paris/Lyon, France</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="cv_edu_exp_box mt-4">
                                <div className="row">
                                    <div className="cv_edu_exp_year tag-year">2018 - 2025</div>
                                    <div className="col-lg-12">
                                        <div className="cb_edu_exp_detail">
                                            <h4>Head of Data | Data Engineer | Data Scientist</h4>
                                            <h5>Adot - Paris, France</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="cv_edu_exp_box mt-4">
                                <div className="row">
                                    <div className="cv_edu_exp_year tag-year">2018 - 2019</div>
                                    <div className="col-lg-12">
                                        <div className="cb_edu_exp_detail">
                                            <h4>Cofondateur & Directeur Général</h4>
                                            <h5>DataDeer - Paris, France</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="cv_edu_exp_box mt-4">
                                <div className="row">
                                    <div className="cv_edu_exp_year tag-year">2017</div>
                                    <div className="col-lg-12">
                                        <div className="cb_edu_exp_detail">
                                            <h4>Développeur | Data Scientist</h4>
                                            <h5>Général Electric - Paris, France</h5>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EducationExperienceComponent;